<template>
  <div class="noPermissions">
    <svg-icon icon-class="nopermissions" :style="{ fontSize: size }"></svg-icon>
    <h3 class="ant-result-subtitle">{{ title }}<slot name="link"></slot></h3>
  </div>
</template>
<script>
export default {
  name: 'NoPermissions',
  props: {
    size: {
      type: String,
      default: '300px'
    },
    title: {
      type: String,
      default: '用户无任何权限，请联系管理员'
    }
  }
};
</script>

<style scoped>
.noPermissions {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 24px auto;
}
h3 {
  margin-top: 24px;
  font-weight: normal;
}
.ant-result-subtitle {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NoPermissions/index.vue